<template>
  <div class="cat-quiz-results">
    <CatLoadingCover
      v-if="isLoading"
      :isCat="false"
    />
    <CatQuizItem
      v-if="catPage"
      :quiz="catPage"
    />
    <CatPagesPagination
      v-if="catPage"
      :pagination="pagination"
      :routeName="routeName"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isEmpty, isNil, isArray, omitBy, isUndefined } from 'lodash';

import CatLoadingCover from '../../viewer-cat-pages/components/CatLoadingCover';
import CatQuizItem from '../../viewer-cat-pages/views/CatQuizItem';
import CatPagesPagination from '../../viewer-cat-pages/components/CatPagesPagination';

export default {
  name: 'cat-quiz-results',

  data() {
    return {
      isLoading: false,
    };
  },

  components: {
    CatLoadingCover,
    CatQuizItem,
    CatPagesPagination,
  },

  computed: {
    ...mapGetters({
      routeName: 'getRouteName',
      routeParams: 'getRouteParams',
      routeQuery: 'getRouteQuery',
      catPage: 'getCatPage',
      pagination: 'getCatPagesPagination',
      catQuizResults: 'getCatQuizResults',
      catQuizResult: 'getCatQuizResult',
    }),

    catPageId() {
      if (isEmpty(this.catQuizResult)) {
        return null;
      }

      return this.catQuizResult.page_id;
    },
  },

  methods: {
    ...mapActions([
      'fetchCatQuizResults',
      'fetchResultCatsPage',
      'fetchCatPagesPagination',
      'fetchPageAnswerStatistics',
      'fetchPageQuizResultCache',
    ]),

    getCoreConceptIdQueries() {
      const coreConceptIds = this.routeQuery['core_concept_ids[]'];
      if (isEmpty(coreConceptIds)) {
        return undefined;
      }
      return isArray(coreConceptIds) ? coreConceptIds : [coreConceptIds];
    },
  },

  beforeMount() {
    if (isEmpty(this.routeQuery)) {
      return this.$router.push('/404');
    }

    const params = omitBy({
      user_id: this.routeQuery.user_id,
      per_page: this.routeQuery.per_page || 100,
      start_date: this.routeQuery.start_date,
      end_date: this.routeQuery.end_date,
      start_at: this.routeQuery.start_at,
      end_at: this.routeQuery.end_at,
      core_concept_ids: this.getCoreConceptIdQueries(),
      bookmark_group_id: this.routeQuery.bookmark_group_id,
      subject_id: this.routeQuery.subject_id,
      cat_id: this.routeQuery.cat_id,
    }, isUndefined);

    this.isLoading = true;
    return this.fetchCatQuizResults(params)
      .then(() => (
        this.fetchCatPagesPagination({
          total: this.catQuizResults.length,
          page: this.routeParams.page,
          prePage: 0,
          quizPosition: 0,
        })
      ))
      .then(() => {
        if (isNil(this.catPageId)) {
          return this.$router.push('/404');
        }

        return this.fetchResultCatsPage({
          catPageId: this.catPageId,
        });
      })
      .then(() => {
        if (this.catPage.page_type.name === 'multiple_choice') {
          return this.fetchPageAnswerStatistics({ pageId: this.catPage.id });
        }

        return true;
      })
      .then(() => (
        this.fetchPageQuizResultCache({ pageId: this.catPage.id })
      ))
      .finally(() => {
        this.isLoading = false;
      });
  },

  watch: {
    $route() {
      this.isLoading = true;
      this.fetchCatPagesPagination({
        total: this.catQuizResults.length,
        page: this.routeParams.page,
        prePage: 0,
        quizPosition: 0,
      })
        .then(() => {
          if (isNil(this.catPageId)) {
            return this.$router.push('/404');
          }

          return this.fetchResultCatsPage({
            catPageId: this.catPageId,
          });
        })
        .then(() => {
          if (this.catPage.page_type.name === 'multiple_choice') {
            return this.fetchPageAnswerStatistics({ pageId: this.catPage.id });
          }

          return true;
        })
        .then(() => (
          this.fetchPageQuizResultCache({ pageId: this.catPage.id })
        ))
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .cat-quiz-results {
    user-select: none;
    background: #ffffff;
    min-height: 100%;
    overflow: auto;
    padding-bottom: 84px;
  }
</style>
